export default {
  computed: {
    env() {
      return this.production ? 'Production' : 'Test'
    },
    production: {
      get() {
        return this.$store.state.env === 'PROD'
      },
      set(value) {
        this.$store.commit('setEnv', value ? 'PROD' : 'TEST')
        if (this.auth.isAuthenticated())
          this.logout(true)
      }
    }
  }
}
